import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ChiSiamo from "../views/ChiSiamo";
import Login from "../views/Login";
import Contatti from "../views/Contatti";
import store from "../store";


Vue.use(VueRouter);

const routes = [
  {path: '/', name: 'Home', component: Home},
  {path: '/adv2024', name: 'ADV2024', component: () => import(/* webpackChunkName: "about" */ '../views/ADV2024.vue')},
  {path: '/adv', name: 'ADV', component: () => import(/* webpackChunkName: "about" */ '../views/ADV.vue')},
  {path: '/menscollection', name: 'ADV-Uomo', component: () => import(/* webpackChunkName: "about" */ '../views/ADV-Uomo.vue')},
  {path: '/blitzSS21', name: 'Lookbook1', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook1.vue')},
  {path: '/positanocoutureSS21', name: 'Lookbook2', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook2.vue')},
  {path: '/blitzSS22', name: 'Lookbook3', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook3.vue')},
  {path: '/positanocoutureSS22', name: 'Lookbook4', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook4.vue')},
  {path: '/positanocoutureforblitzSS23', name: 'Lookbook5', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook5.vue')},
  {path: '/positanocoutureforblitzSS24', name: 'Lookbook6', component: () => import(/* webpackChunkName: "about" */ '../views/Lookbook6.vue'),  meta: {requiresAuth: true}},
  {path: '/ourstory', name: 'ChiSiamo', component: ChiSiamo},
  {path: '/contact', name: 'Contatti', component: Contatti},
  {path: '/login', name: 'Login', component: Login},
  {path: "*", component: Home}
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return
    }
    next({
      path: '/login',
      query: { nextUrl: to.fullPath }
    });

  } else {
    next();
  }
});

export default router
